import React, { useEffect, useState } from 'react'
import "./Vender"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import $ from 'jquery';
import { Route, Routes, useLocation, Outlet, Navigate, Link } from 'react-router-dom'
import Landing1 from './Pages/Home/Landing1/Landing1' //
import Landing2 from './Pages/Home/Landing2/Landing2'
import Landing3 from './Pages/Home/Landing3/Landing3'
import Landing4 from './Pages/Home/Landing4/Langing4'
import Header1, { StickyButtons } from './Layout/Header/Header1'
import TopCategoriesBar from './Layout/Header/TopCategoriesBar'
import Footer1 from './Layout/Footer/Footer1'
import './Layout/Header/Header1.css'
import HomePage from './defaultPages/HomePage'
import Login from './defaultPages/Login/Login'
import Signup from './defaultPages/Signup/Signup'
import AboutUs from './Pages/Company/AboutUs'
import ProductGrid from './Pages/Shop/ProductGrid'
import ProductList from './Pages/Shop/ProductList';
import ProductSingle from './Pages/Shop/ProductSingle';
import ProductCart from './Pages/Shop/ProductCart';
import CheckOut from './Pages/Shop/Checkout';
import OrderComplete from './Pages/Shop/OrderComplete';
import AccordionPage from './Pages/Feature/AccordionPage';
import CounterPage from './Pages/Feature/CounterPage';
import Header2 from './Layout/Header/Header2';
import FeatureIconPage from './Pages/Feature/FeatureIconPage';
import FeaturePricePage from './Pages/Feature/FeaturePricePage';
import FeatureTeamPage from './Pages/Feature/FeatureTeamPage';
import FeatureTestimonialPage from './Pages/Feature/FeatureTestimonialPage';
import FeatureBlogPage from './Pages/Feature/FeatureBlog';
import BlogStyle from './Pages/Blog/BlogStyle';
import BlogListing1 from './Pages/Blog/BlogListing1';
import BlogListing2 from './Pages/Blog/BlogListing2';
import BlogSingle from './Pages/Blog/BlogSingle';
import AboutUs2 from './Pages/Company/AboutUs2';
import Career from './Pages/Company/Career';
import CareerSingle from './Pages/Company/CareerSingle';
import Contact1 from './Pages/Contact/Contact1';
import Contact2 from './Pages/Contact/Contact2';
import Signin2 from './defaultPages/SignIn2';
import Forgotpassword from './defaultPages/ForgetPassword';
import FAQ from './Pages/Utilities/FaqPage';
import Pricing from './Pages/Utilities/PricingPage';
import PricingHe from './Pages/Utilities/PricingPageHe';
import PrivacyPolicy from './Pages/Utilities/Privacy';
import TermsConditions from './Pages/Utilities/T&CPage';
import Maintenance from './Pages/Utilities/MaintanancePage';
import ComingSoon from './Pages/Utilities/ComingSoon';
import Error404 from './Pages/Utilities/Error404.js';
import Error404WithoutHeaderFooter from './Componet/NotDefinedPage';
import Signupcomponent from './defaultPages/Signup/Component/Signupcomponet'
import Verification from './defaultPages/Verify/Verify';
import Dev from './Pages/Utilities/DEV1.js'
import Ops from './Pages/Utilities/OPS1.js'
import Sec from './Pages/Utilities/SEC1.js'
import Consulting from './Pages/Utilities/CONS1.js'
import HE from './Pages/Utilities/HE1.js'
import Aca from './Pages/Utilities/ACA1.js'
import NOC from './Pages/Utilities/NOC1.js'
import PrivateCloud from './Pages/Utilities/PRIVATECLOUD1.js'
import Disaster from './Pages/Utilities/DISASTER.js'
import ServerCare from './Pages/Utilities/SERVERCARE.js'
import Calculator from './Pages/Utilities/CALCULATOR.js'
import PricingCalculator from './Pages/Utilities/PRICINGCALCULATOR.js'
import DisabledService from './Componet/DisabledService.js'
import NotificationBanner from './Componet/Notification/NotificationBanner';
import Marketplace from './Componet/Marketplace/Marketplace';
import WordPress from './Pages/WordPress/WordPress';
import WordPressEn from './Pages/WordPress/WordPressEn';
import WooCommerce from './Pages/WooCommerce/WooCommerce';
import WooCommerceEn from './Pages/WooCommerce/WooCommerceEn';
import GlobalDeploy from './Componet/GlobalDeploy/GlobalDeploy';
import Cloud from './Pages/Cloud/Cloud';
import CloudEn from './Pages/Cloud/CloudEn';
import WebHosting from './Pages/Hosting/WebHosting';
import Compute from './Pages/Hosting/Compute';
import ManagedServices from './Pages/Hosting/ManagedServices';
import ManagedCDN from './Pages/ManagedServices/ManagedCDN';
import ServerManagement from './Pages/ManagedServices/ServerManagement';
import AWSManagement from './Pages/ManagedServices/AWSManagement';
import AuroraDB from './Pages/ManagedServices/AuroraDB';
import CentralizedMonitoring from './Pages/ManagedServices/CentralizedMonitoring';
import DevSecOpsDaily from './Pages/ManagedServices/DevSecOpsDaily';
import DevSecOpsWeekly from './Pages/ManagedServices/DevSecOpsWeekly';
import ManagedCyberDefence from './Pages/ManagedServices/ManagedCyberDefence';
import SharedHosting from './Pages/Hosting/SharedHosting';
import WordPressHosting from './Pages/Hosting/WordPressHosting';
import NextJsHosting from './Pages/Hosting/NextJsHosting';
import UnmanagedWordPress from './Pages/Hosting/UnmanagedWordPress';
import DataOps from './Pages/Solutions/DataOps';

// Hebrew Solutions Pages
import DevHe from './Pages/Solutions/He/DEV1He.js';
import OpsHe from './Pages/Solutions/He/OPS1He.js';
import SecHe from './Pages/Solutions/He/SEC1He.js';
import ConsHe from './Pages/Solutions/He/CONS1He.js';
import AcaHe from './Pages/Solutions/He/ACA1He.js';
import NOCHe from './Pages/Solutions/He/NOC1He.js';
import PrivateCloudHe from './Pages/Solutions/He/PRIVATECLOUD1He.js';
import DisasterHe from './Pages/Solutions/He/DISASTERHe.js';
import ServerCareHe from './Pages/Solutions/He/SERVERCAREHe.js';
import DataOpsHe from './Pages/Solutions/He/DataOpsHe.js';
import TechGrowthHe from './Pages/Solutions/He/TechGrowthHe.js';
import ProjectsPlatformHe from './Pages/Solutions/He/ProjectsPlatformHe.js';
import GenAIHe from './Pages/Solutions/He/GenAIHe.js';
import GenAI from './Pages/Solutions/GenAI.js';

// Hebrew Managed Services Pages
import ManagedCDNHe from './Pages/ManagedServices/He/ManagedCDNHe';
import ServerManagementHe from './Pages/ManagedServices/He/ServerManagementHe';
import AWSManagementHe from './Pages/ManagedServices/He/AWSManagementHe';
import AuroraDBHe from './Pages/ManagedServices/He/AuroraDBHe';
import CentralizedMonitoringHe from './Pages/ManagedServices/He/CentralizedMonitoringHe';
import DevSecOpsDailyHe from './Pages/ManagedServices/He/DevSecOpsDailyHe';
import ManagedCyberDefenceHe from './Pages/ManagedServices/He/ManagedCyberDefenceHe';
import SharedHostingHe from './Pages/Hosting/He/SharedHostingHe';
import ComputeHe from './Pages/Hosting/He/ComputeHe';
import WordPressHostingHe from './Pages/Hosting/He/WordPressHostingHe';
import NextJsHostingHe from './Pages/Hosting/He/NextJsHostingHe';
import { installThirdPartyFocusScrollGuard } from './utils/preventThirdPartyFocusScroll';




// Hebrew Header Toggle Button Component
const HebrewHeaderToggle = () => {
  const location = useLocation();
  const isHomePageHe = location.pathname.startsWith('/he') || location.pathname === '/pricing-he' || location.pathname === '/Pricing-Calculator';
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isSmallBusinessOpen, setIsSmallBusinessOpen] = useState(false);
  const [isClientsOpen, setIsClientsOpen] = useState(false);
  const [isPricingOpen, setIsPricingOpen] = useState(false);
  const [isManagedOpen, setIsManagedOpen] = useState(false);
  const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
  const [isHostingOpen, setIsHostingOpen] = useState(false);
  const [isLegalOpen, setIsLegalOpen] = useState(false);
  const navItems = [
    { to: '/he#about-us', label: '\u05d0\u05d5\u05d3\u05d5\u05ea\u05d9\u05e0\u05d5' },
  ];

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .he-toggle-btn:hover,
        .he-mobile-nav-toggle:hover,
        .he-mobile-nav-link:hover {
          background: #f3f4f6;
          border-color: #d1d5db;
          color: #111827;
        }
        .he-toggle-btn:active,
        .he-mobile-nav-toggle:active {
          transform: translateY(0);
        }
        .he-header-shell {
          position: relative;
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          animation: fadeIn 0.3s ease-out;
        }
        .he-header-shell .hero-top-banner {
          position: static;
          z-index: auto;
          padding: 10px 0;
          background: linear-gradient(135deg, #000000 0%, #005c82 100%);
          backdrop-filter: none;
          border-bottom: 1px solid rgba(255, 255, 255, 0.12);
          direction: rtl;
        }
        .he-header-shell .top-banner-content {
          direction: rtl;
        }
        .he-header-shell .banner-badge {
          background: linear-gradient(135deg, #22c55e 0%, #10b981 100%);
          color: #ffffff;
        }
        .he-header-shell .banner-text {
          color: rgba(255, 255, 255, 0.9);
        }
        .he-header-bar {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 10px 18px 10px 0px;
          gap: 16px;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
        }
        .he-brand-cluster {
          display: flex;
          align-items: center;
          gap: 10px;
          flex: 0 0 auto;
        }
        .he-logo-section {
          display: flex;
          align-items: center;
          flex: 0 0 auto;
          margin-left: -35px;
        }
        .he-nav-links {
          display: flex;
          direction: rtl;
          align-items: center;
          justify-content: flex-start;
          gap: 16px;
          flex: 1 1 auto;
          min-width: 0;
          margin-inline-end: auto;
          padding-inline-start: 12px;
        }
        .he-nav-link {
          color: #475569;
          text-decoration: none;
          font-size: 13px;
          font-weight: 500;
          line-height: 1.2;
          white-space: nowrap;
          transition: color 0.2s ease;
        }
        .he-nav-link:hover {
          color: #0f172a;
        }
        .he-nav-featured-link {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 10px 14px;
          border-radius: 16px;
          text-decoration: none;
          background: linear-gradient(135deg, #0f172a 0%, #0f4c81 48%, #06b6d4 100%);
          color: #ffffff;
          box-shadow: 0 14px 28px rgba(15, 76, 129, 0.22);
          transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
          max-width: 290px;
          min-width: 0;
        }
        .he-nav-featured-link:hover {
          color: #ffffff;
          transform: translateY(-1px);
          box-shadow: 0 18px 34px rgba(15, 76, 129, 0.28);
          filter: saturate(1.05);
        }
        .he-nav-featured-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.12);
          flex: 0 0 auto;
        }
        .he-nav-featured-icon i {
          font-size: 18px;
        }
        .he-nav-featured-copy {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
          text-align: right;
          line-height: 1.2;
        }
        .he-nav-featured-eyebrow {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0;
          color: rgba(255, 255, 255, 0.76);
        }
        .he-nav-featured-title {
          font-size: 14px;
          font-weight: 700;
          color: #ffffff;
          white-space: normal;
          overflow-wrap: anywhere;
        }
        .he-nav-featured-subtitle {
          font-size: 11px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.88);
          white-space: normal;
          overflow-wrap: anywhere;
        }
        .he-nav-dropdown {
          position: relative;
          display: flex;
          align-items: center;
        }
        .he-nav-dropdown-trigger {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 0;
          border: none;
          background: transparent;
          color: #475569;
          font-size: 13px;
          font-weight: 500;
          line-height: 1.2;
          cursor: pointer;
          white-space: nowrap;
          transition: color 0.2s ease;
        }
        .he-nav-dropdown-trigger:hover {
          color: #0f172a;
        }
        .he-nav-dropdown-trigger i {
          font-size: 12px;
        }
        .he-nav-dropdown-menu {
          position: absolute;
          top: calc(100% + 10px);
          right: 0;
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 220px;
          padding: 10px;
          border: 1px solid #e5e7eb;
          border-radius: 14px;
          background: #ffffff;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
          z-index: 20;
          direction: rtl;
          text-align: right;
        }
        .he-nav-dropdown-menu::before {
          content: "";
          position: absolute;
          top: -12px;
          right: 0;
          left: 0;
          height: 12px;
          background: transparent;
        }
        .he-nav-dropdown-link {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          min-height: 38px;
          padding: 0 12px;
          border-radius: 10px;
          color: #334155;
          text-decoration: none;
          font-size: 12px;
          font-weight: 500;
          transition: background 0.2s ease, color 0.2s ease;
        }
        .he-nav-dropdown-link:hover {
          background: #f8fafc;
          color: #0f172a;
        }
        .he-nav-dropdown-link-subtle {
          font-weight: 600;
          color: #0f4c81;
          background: linear-gradient(135deg, rgba(15, 76, 129, 0.06) 0%, rgba(15, 76, 129, 0.02) 100%);
        }
        /* Small-business menu: only service titles are links. */
        .he-small-business-menu {
          min-width: 310px;
          max-width: calc(100vw - 24px);
        }
        .he-small-business-entry {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 3px;
          padding: 8px 12px;
          border-radius: 10px;
          direction: rtl;
          text-align: right;
        }
        .he-small-business-entry-title {
          color: #334155;
          font-size: 12px;
          font-weight: 600;
          line-height: 1.5;
          text-decoration: none;
        }
        .he-small-business-entry-title:hover,
        .he-small-business-entry-title:focus-visible {
          color: #0f4c81;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .he-small-business-entry-subtitle {
          color: #64748b;
          font-size: 11px;
          font-weight: 400;
          line-height: 1.5;
        }
        .he-small-business-entry--mobile {
          padding: 10px 12px;
          background: #f8fafc;
        }
        .he-logo-section {
          display: flex;
          align-items: center;
          flex: 0 0 auto;
          margin-left: -35px;
          transition: margin-left 0.3s ease;
        }
        .he-logo-section.is-home {
          margin-left: 25px;
        }
        .he-logo-img {
          height: 50px;
          width: auto;
          object-fit: contain;
          display: block;
          margin: 0;
          transition: height 0.3s ease;
        }
        .he-logo-img.is-home {
          height: 48px;
        }
        .he-toggle-inner {
          display: flex;
          align-items: center;
          gap: 8px;
          justify-content: flex-end;
          flex: 0 0 auto;
        }
        .he-toggle-btn,
        .he-mobile-nav-toggle {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          min-height: 34px;
          padding: 0 12px;
          border-radius: 999px;
          border: 1px solid #dbe2ea;
          background: #ffffff;
          color: #334155;
          text-decoration: none;
          font-weight: 500;
          font-size: 12px;
          line-height: 1;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
        }
        .he-toggle-btn i,
        .he-mobile-nav-toggle i {
          font-size: 14px;
        }
        .he-toggle-btn-primary {
          background: #f8fbfd;
          border-color: #c8d9e8;
          color: #0f4c81;
        }
        .he-toggle-btn-desktop-only {
          display: inline-flex;
        }
        .he-toggle-btn-mobile-only {
          display: none;
        }
        .he-toggle-btn-login {
          background: #fafafa;
          border-color: #d6dbe1;
          color: #1f2937;
        }
        .he-toggle-dropdown {
          position: relative;
        }
        .he-toggle-dropdown-menu {
          position: absolute;
          top: calc(100% + 10px);
          right: 0;
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 230px;
          padding: 10px;
          border: 1px solid #e5e7eb;
          border-radius: 14px;
          background: #ffffff;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
          z-index: 25;
          direction: rtl;
          text-align: right;
        }
        .he-mobile-nav-toggle {
          display: none;
        }
        .he-mobile-nav-toggle {
          background: linear-gradient(135deg, #0f4c81 0%, #0078a8 100%);
          border-color: #0f4c81;
          color: #ffffff;
          box-shadow: 0 8px 20px rgba(15, 76, 129, 0.22);
        }
        .he-mobile-nav-toggle:hover {
          background: linear-gradient(135deg, #0d426f 0%, #006694 100%);
          border-color: #0d426f;
          color: #ffffff;
          transform: translateY(-1px);
        }
        .he-mobile-nav-toggle i {
          color: #ffffff;
        }
        .he-mobile-nav-panel {
          display: none;
        }
        .he-mobile-nav-panel.is-open {
          display: none;
        }
        /* Remove padding from Hebrew page wrapper when headers hidden */
        .hebrew-no-header .modern-feature-section {
          padding-top: 0 !important;
        }
        .hebrew-no-header .modern-feature-section .epic-hero {
          min-height: calc(100vh - 61px);
        }
        @media (min-width: 1025px) and (max-width: 1600px) {
          .he-header-bar {
            justify-content: space-between;
            padding: 8px 12px;
            gap: 10px;
          }
          .he-brand-cluster {
            gap: 6px;
          }
          .he-logo-section {
            flex: 0 0 auto;
            margin-left: 0;
          }
          .he-logo-section.is-home {
            margin-left: 0;
          }
          .he-logo-img,
          .he-logo-img.is-home {
            height: 42px;
          }
          .he-nav-links {
            display: flex;
            margin: 0 !important;
            padding: 0 8px;
            justify-content: flex-start;
            flex: 1;
            flex-wrap: wrap;
            gap: 8px;
          }
          .he-nav-link,
          .he-nav-dropdown-trigger {
            font-size: 12px;
          }
          .he-toggle-inner {
            flex: 0 0 auto;
            margin: 0 !important;
            gap: 6px;
          }
          .he-toggle-btn {
            min-height: 32px;
            padding: 0 9px;
            font-size: 11px;
          }
          .he-nav-featured-link {
            max-width: 92px;
            padding: 8px 10px;
            border-radius: 12px;
          }
          .he-nav-featured-subtitle {
            display: none;
          }
          .he-nav-featured-copy {
            gap: 1px;
          }
        }
        @media (max-width: 1024px) {
          .he-header-bar {
            padding: 10px 14px;
            gap: 10px;
          }
          .he-brand-cluster {
            gap: 0;
          }
          .he-logo-img {
            height: 55px;
            margin: 0;
          }
          .he-logo-img.is-home {
            height: 54px;
          }
          .he-logo-section.is-home {
            margin-left: 15px;
          }
          .he-nav-links {
            display: none;
          }
          .he-toggle-btn-desktop-only {
            display: none;
          }
          .he-toggle-btn-mobile-only {
            display: inline-flex;
          }
          .he-nav-featured-link {
            display: none;
          }
          .he-nav-dropdown {
            display: none;
          }
          .he-mobile-nav-toggle {
            display: inline-flex;
          }
          .he-toggle-inner {
            margin-inline-start: auto;
          }
          .he-mobile-nav-panel.is-open {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 0 14px 12px;
            border-top: 1px solid #eef2f7;
            background: #ffffff;
            direction: rtl;
            text-align: right;
          }
          .he-mobile-nav-link {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            min-height: 40px;
            padding: 0 12px;
            border-radius: 12px;
            border: 1px solid #e5e7eb;
            background: #ffffff;
            color: #334155;
            text-decoration: none;
            font-size: 13px;
            font-weight: 500;
            text-align: right;
            transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
          }
          .he-mobile-nav-link.he-mobile-nav-link-featured {
            gap: 12px;
            min-height: 58px;
            padding: 12px 14px;
            border: 1px solid rgba(6, 182, 212, 0.18);
            border-radius: 16px;
            background: linear-gradient(135deg, #0f172a 0%, #0f4c81 48%, #06b6d4 100%);
            color: #ffffff;
            box-shadow: 0 16px 30px rgba(15, 76, 129, 0.18);
          }
          .he-mobile-nav-link-featured .he-mobile-nav-featured-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 38px;
            height: 38px;
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.14);
            flex: 0 0 auto;
          }
          .he-mobile-nav-link-featured .he-mobile-nav-featured-icon i {
            font-size: 19px;
          }
          .he-mobile-nav-link-featured .he-mobile-nav-featured-copy {
            display: flex;
            flex-direction: column;
            gap: 2px;
            min-width: 0;
            line-height: 1.2;
            text-align: right;
          }
          .he-mobile-nav-link-featured .he-mobile-nav-featured-eyebrow {
            font-size: 11px;
            font-weight: 700;
            color: rgba(255, 255, 255, 0.76);
          }
          .he-mobile-nav-link-featured .he-mobile-nav-featured-title {
            font-size: 14px;
            font-weight: 700;
            color: #ffffff;
            white-space: normal;
            overflow-wrap: anywhere;
          }
          .he-mobile-nav-link-featured .he-mobile-nav-featured-subtitle {
            font-size: 11px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.88);
            white-space: normal;
            overflow-wrap: anywhere;
          }
          .he-mobile-nav-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          .he-mobile-nav-group-trigger {
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-height: 40px;
            padding: 0 12px;
            border-radius: 12px;
            border: 1px solid #e5e7eb;
            background: #ffffff;
            color: #334155;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
          }
          .he-mobile-nav-sublink-subtle {
            font-weight: 600;
            color: #0f4c81;
          }
          .he-mobile-nav-sublinks {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-right: 12px;
            direction: rtl;
          }
          .he-mobile-nav-sublink {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            min-height: 36px;
            padding: 0 12px;
            border-radius: 10px;
            background: #f8fafc;
            color: #334155;
            text-decoration: none;
            font-size: 12px;
            font-weight: 500;
            text-align: right;
          }
          .hebrew-no-header .modern-feature-section .epic-hero {
            min-height: calc(100vh - 50px);
          }
        }
        @media (max-width: 480px) {
          .he-header-shell .hero-top-banner {
            padding: 8px 0;
          }
          .he-header-shell .top-banner-content {
            gap: 6px;
          }
          .he-header-shell .banner-text {
            font-size: 11px;
          }
          .he-header-bar {
            padding: 8px 10px;
            gap: 8px;
          }
          .he-logo-img {
            height: 46px;
            margin: 0;
          }
          .he-logo-img.is-home {
            height: 26px;
          }
          .he-logo-section.is-home {
            margin-left: 10px;
          }
          .he-toggle-inner {
            gap: 6px;
          }
          .he-toggle-btn,
          .he-mobile-nav-toggle {
            min-height: 30px;
            padding: 0 10px;
            font-size: 11px;
          }
          .he-toggle-btn i,
          .he-mobile-nav-toggle i {
            font-size: 12px;
          }
          .he-mobile-nav-panel.is-open {
            padding: 0 10px 10px;
          }
          .he-mobile-nav-link {
            min-height: 36px;
            font-size: 12px;
          }
          .hebrew-no-header .modern-feature-section .epic-hero {
            min-height: calc(100vh - 42px);
          }
        }
      `}</style>
      <div className="he-header-shell">
        <div className="hero-top-banner">
          <div className="container">
            <div className="top-banner-content">
              <span className="banner-badge">זמין עכשיו!</span>
              <span className="banner-text"> ענן היברידי זמין כעת בשני מתקנים באירופה</span>
            </div>
          </div>
        </div>
        <div className="he-header-bar">
          <div className="he-brand-cluster">
            <Link to="/he" className={`he-logo-section ${isHomePageHe ? 'is-home' : ''}`} aria-label="Epicfinal Hebrew home">
              <img
                src="/newlogox2x2-trimmed.png"
                alt="Epicfinal Cloud Services"
                className={`he-logo-img ${isHomePageHe ? 'is-home' : ''}`}
              />
            </Link>
            <Link
              to="/"
              className="he-toggle-btn he-toggle-btn-primary he-toggle-btn-desktop-only"
            >
              <i className="las la-globe"></i>
              <span>English Site</span>
            </Link>
          </div>
          <nav className="he-nav-links" aria-label="Hebrew quick navigation">
            <div
              className="he-nav-dropdown"
              onMouseEnter={() => setIsSolutionsOpen(true)}
              onMouseLeave={() => setIsSolutionsOpen(false)}
            >
              <button
                type="button"
                className="he-nav-dropdown-trigger"
                onClick={() => setIsSolutionsOpen((prev) => !prev)}
                aria-expanded={isSolutionsOpen}
              >
                <span>פתרונות</span>
                <i className={`las ${isSolutionsOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
              </button>
              {isSolutionsOpen && (
                <div className="he-nav-dropdown-menu">
                  <a
                    href="/he#solutions"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    כל הפתרונות
                  </a>
                  <Link
                    to="/he/consulting"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    תכנון ומחקר
                  </Link>
                  <Link
                    to="/he/development"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    פיתוח תוכנה
                  </Link>
                  <Link
                    to="/he/operations"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    דבאופס
                  </Link>
                  <Link
                    to="/he/development"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    אינטגרציות
                  </Link>
                  <Link
                    to="/he/security"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    סייבר
                  </Link>
                  <Link
                    to="/he/consulting"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    ייעוץ ותמיכה
                  </Link>
                  <Link
                    to="/he/private_cloud"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    ענן פרטי
                  </Link>
                  <Link
                    to="/he/dataops"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    DataOps
                  </Link>
                  <Link
                    to="/he/noc"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    מרכז בקרה ורשת (NOC)
                  </Link>
                  <Link
                    to="/he/managed_service"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    ניהול שרתים
                  </Link>
                  <Link
                    to="/he/disaster_recovery"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    התאוששות מאסון
                  </Link>
                  <Link
                    to="/he/academy"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsSolutionsOpen(false)}
                  >
                    אקדמיה והכשרות
                  </Link>
                </div>
              )}
            </div>
            <div
              className="he-nav-dropdown"
              onMouseEnter={() => setIsManagedOpen(true)}
              onMouseLeave={() => setIsManagedOpen(false)}
            >
              <button
                type="button"
                className="he-nav-dropdown-trigger"
                onClick={() => setIsManagedOpen((prev) => !prev)}
                aria-expanded={isManagedOpen}
              >
                <span>שירותים מנוהלים</span>
                <i className={`las ${isManagedOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
              </button>
              {isManagedOpen && (
                <div className="he-nav-dropdown-menu">
                  <a
                    href="/he#managed-services"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    כל השירותים מנוהלים
                  </a>
                  <Link
                    to="/he/managed-cdn"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    CDN מנוהל - Cloudflare
                  </Link>
                  <Link
                    to="/he/aws-management"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    ניהול AWS אוטומטי
                  </Link>
                  <Link
                    to="/he/centralized-monitoring"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    ניטור וגיבוי מרכזי
                  </Link>
                  <Link
                    to="/he/server-management"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    ניהול שרתים חיצוניים
                  </Link>
                  <Link
                    to="/he/aurora-database"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    מסד נתונים Aurora מנוהל
                  </Link>
                  <Link
                    to="/he/devsecops-daily"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    מנוי DevOps לפי דרישה
                  </Link>
                  <Link
                    to="/he/managed-cyber-defence"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsManagedOpen(false)}
                  >
                    הגנת סייבר מנוהלת 24/7
                  </Link>
                </div>
              )}
            </div>
            <div
              className="he-nav-dropdown"
              onMouseEnter={() => setIsHostingOpen(true)}
              onMouseLeave={() => setIsHostingOpen(false)}
            >
              <button
                type="button"
                className="he-nav-dropdown-trigger"
                onClick={() => setIsHostingOpen((prev) => !prev)}
                aria-expanded={isHostingOpen}
              >
                <span>אחסון וענן</span>
                <i className={`las ${isHostingOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
              </button>
              {isHostingOpen && (
                <div className="he-nav-dropdown-menu">
                  <a
                    href="/he#hosting-cloud"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    כל האחסון והענן
                  </a>
                  <Link
                    to="/he/shared-hosting"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    אחסון אתרים
                  </Link>
                  <Link
                    to="/he/compute"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    שרתי ענן VPS
                  </Link>
                  <Link
                    to="/he/wordpress-hosting"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    אחסון וורדפרס
                  </Link>
                  <Link
                    to="/he/woocommerce"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    אחסון WooCommerce
                  </Link>
                  <Link
                    to="/he/nextjs-hosting"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    אחסון Next.js
                  </Link>
                  <Link
                    to="/marketplace"
                    state={{ language: 'he' }}
                    className="he-nav-dropdown-link he-nav-dropdown-link-subtle"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    מוצרי ענן מנוהלים
                  </Link>
                  <a
                    href="https://my.epicfinal.com/cart.php?a=add&domain=register&language=hebrew"
                    className="he-nav-dropdown-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    רישום דומיין
                  </a>
                  <Link
                    to="/he/wordpress"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsHostingOpen(false)}
                  >
                    וורדפרס בניהול מלא
                  </Link>
                </div>
              )}
            </div>
            <div className="he-nav-dropdown">
              <button
                type="button"
                className="he-nav-dropdown-trigger"
                onClick={() => setIsSmallBusinessOpen((prev) => !prev)}
                aria-expanded={isSmallBusinessOpen}
              >
                <span>{'\u05e2\u05e1\u05e7\u05d9\u05dd \u05e7\u05d8\u05e0\u05d9\u05dd'}</span>
                <i className={`las ${isSmallBusinessOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
              </button>
              {isSmallBusinessOpen && (
                <div className="he-nav-dropdown-menu he-small-business-menu">
                  <div className="he-small-business-entry">
                    <a
                      href="https://promo.eu.epicfinal-cloud.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="he-small-business-entry-title"
                      onClick={() => setIsSmallBusinessOpen(false)}
                    >
                      בניית אתרים לעסקים
                    </a>
                    <span className="he-small-business-entry-subtitle">אתרים מקצועיים, חנויות, אחסון ותחזוקה</span>
                  </div>
                  <div className="he-small-business-entry">
                    <a
                      href="https://growth.epicfinal.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="he-small-business-entry-title"
                      onClick={() => setIsSmallBusinessOpen(false)}
                    >
                      מערכות שיווק ומכירות
                    </a>
                    <span className="he-small-business-entry-subtitle">לידים, CRM, אוטומציות, דאטה ו־AI</span>
                  </div>
                  <div className="he-small-business-entry">
                    <Link
                      to="/he/tech-growth"
                      className="he-small-business-entry-title"
                      onClick={() => setIsSmallBusinessOpen(false)}
                    >
                      ליווי טכנולוגי לעסקים
                    </Link>
                    <span className="he-small-business-entry-subtitle">ייעוץ, מערכות ניהול, אוטומציה ודאטה</span>
                  </div>
                </div>
              )}
            </div>
            <div className="he-nav-dropdown">
              <button
                type="button"
                className="he-nav-dropdown-trigger"
                onClick={() => setIsLegalOpen((prev) => !prev)}
                aria-expanded={isLegalOpen}
              >
                <span>תנאים ופרטיות</span>
                <i className={`las ${isLegalOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
              </button>
              {isLegalOpen && (
                <div className="he-nav-dropdown-menu">
                  <Link
                    to="/terms_conditions#hebrew-section"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsLegalOpen(false)}
                  >
                    תנאי שימוש
                  </Link>
                  <Link
                    to="/privacy_policy#hebrew-version"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsLegalOpen(false)}
                  >
                    מדיניות הפרטיות
                  </Link>
                </div>
              )}
            </div>
            <div className="he-nav-dropdown">
              <button
                type="button"
                className="he-nav-dropdown-trigger"
                onClick={() => setIsPricingOpen((prev) => !prev)}
                aria-expanded={isPricingOpen}
              >
                <span>מחירים</span>
                <i className={`las ${isPricingOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
              </button>
              {isPricingOpen && (
                <div className="he-nav-dropdown-menu">
                  <Link
                    to="/pricing-he"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsPricingOpen(false)}
                  >
                    מנוי DevSecOps ONE
                  </Link>
                  <Link
                    to="/he/pricing-calculator"
                    className="he-nav-dropdown-link"
                    onClick={() => setIsPricingOpen(false)}
                  >
                    מחשבון עלות
                  </Link>
                </div>
              )}
            </div>
            {navItems.map((item) => (
              item.to.includes('#') ? (
                <a key={item.to} href={item.to} className="he-nav-link">
                  {item.label}
                </a>
              ) : (
                <Link key={item.to} to={item.to} className="he-nav-link">
                  {item.label}
                </Link>
              )
            ))}
          </nav>
          <div className="he-toggle-inner">
            <button
              type="button"
              className="he-mobile-nav-toggle"
              onClick={() => setIsMobileNavOpen((prev) => !prev)}
              aria-label="Open navigation menu"
              aria-expanded={isMobileNavOpen}
            >
              <i className="las la-bars"></i>
            </button>
            <Link
              to="/"
              className="he-toggle-btn he-toggle-btn-primary he-toggle-btn-mobile-only"
            >
              <i className="las la-globe"></i>
              <span>English Site</span>
            </Link>
            <div className="he-toggle-dropdown">
              <button
                type="button"
                className="he-toggle-btn he-toggle-btn-login"
                onClick={() => setIsClientsOpen((prev) => !prev)}
                aria-expanded={isClientsOpen}
              >
                <i className="las la-user-circle"></i>
                <span>{'\u05db\u05e0\u05d9\u05e1\u05ea \u05dc\u05e7\u05d5\u05d7\u05d5\u05ea'}</span>
                <i className={`las ${isClientsOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
              </button>
              {isClientsOpen && (
                <div className="he-toggle-dropdown-menu">
                  <a
                    href="https://my.epicfinal.com/index.php?rp=%2Flogin&language=hebrew&currency=2"
                    className="he-nav-dropdown-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setIsClientsOpen(false)}
                  >
                    {'\u05d4\u05ea\u05d7\u05d1\u05e8 \u05dc\u05e2\u05e0\u05df'}
                  </a>
                  <a
                    href="https://my.epicfinal.com/register.php?language=hebrew&currency=2"
                    className="he-nav-dropdown-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setIsClientsOpen(false)}
                  >
                    {'\u05d4\u05e8\u05e9\u05dd \u05dc\u05e2\u05e0\u05df'}
                  </a>
                  <a
                    href="https://boarding.eu.epicfinal-cloud.com/login?lang=he"
                    className="he-nav-dropdown-link he-nav-dropdown-link-subtle"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setIsClientsOpen(false)}
                  >
                    {'DevSecOps ONE'}
                  </a>
                </div>
              )}
            </div>
            <Link to="/he/genai" className="he-nav-featured-link">
              <span className="he-nav-featured-copy">
                <span className="he-nav-featured-eyebrow">חדש</span>
                <span className="he-nav-featured-title">GenAI</span>
                <span className="he-nav-featured-subtitle">סביבת בינה מלאכותית לפיתוח אפליקציות</span>
              </span>
            </Link>
          </div>
        </div>
        <div className={`he-mobile-nav-panel${isMobileNavOpen ? ' is-open' : ''}`}>
          <Link
            to="/he/genai"
            className="he-mobile-nav-link he-mobile-nav-link-featured"
            onClick={() => setIsMobileNavOpen(false)}
          >
            <span className="he-mobile-nav-featured-copy">
              <span className="he-mobile-nav-featured-eyebrow">חדש</span>
              <span className="he-mobile-nav-featured-title">GenAI</span>
              <span className="he-mobile-nav-featured-subtitle">סביבת בינה מלאכותית לפיתוח אפליקציות</span>
            </span>
          </Link>

          <div className="he-mobile-nav-group">
            <button
              type="button"
              className="he-mobile-nav-group-trigger"
              onClick={() => setIsSolutionsOpen((prev) => !prev)}
              aria-expanded={isSolutionsOpen}
            >
              <span>פתרונות</span>
              <i className={`las ${isSolutionsOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
            </button>
            {isSolutionsOpen && (
              <div className="he-mobile-nav-sublinks">
                <a
                  href="/he#solutions"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  כל הפתרונות
                </a>
                <Link
                  to="/he/consulting"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  תכנון ומחקר
                </Link>
                <Link
                  to="/he/development"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  פיתוח תוכנה
                </Link>
                <Link
                  to="/he/operations"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  דבאופס
                </Link>
                <Link
                  to="/he/development"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  אינטגרציות
                </Link>
                <Link
                  to="/he/security"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  סייבר
                </Link>
                <Link
                  to="/he/consulting"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  ייעוץ ותמיכה
                </Link>
                <Link
                  to="/he/private_cloud"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  ענן פרטי
                </Link>
                <Link
                  to="/he/dataops"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  DataOps
                </Link>
                <Link
                  to="/he/noc"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  מרכז בקרה ורשת (NOC)
                </Link>
                <Link
                  to="/he/managed_service"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  ניהול שרתים
                </Link>
                <Link
                  to="/he/disaster_recovery"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  התאוששות מאסון
                </Link>
                <Link
                  to="/he/academy"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsSolutionsOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  אקדמיה והכשרות
                </Link>
              </div>
            )}
          </div>
          <div className="he-mobile-nav-group">
            <button
              type="button"
              className="he-mobile-nav-group-trigger"
              onClick={() => setIsManagedOpen((prev) => !prev)}
              aria-expanded={isManagedOpen}
            >
              <span>שירותים מנוהלים</span>
              <i className={`las ${isManagedOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
            </button>
            {isManagedOpen && (
              <div className="he-mobile-nav-sublinks">
                <a
                  href="/he#managed-services"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  כל השירותים מנוהלים
                </a>
                <Link
                  to="/he/managed-cdn"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  CDN מנוהל - Cloudflare
                </Link>
                <Link
                  to="/he/aws-management"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  ניהול AWS אוטומטי
                </Link>
                <Link
                  to="/he/centralized-monitoring"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  ניטור וגיבוי מרכזי
                </Link>
                <Link
                  to="/he/server-management"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  ניהול שרתים חיצוניים
                </Link>
                <Link
                  to="/he/aurora-database"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  מסד נתונים Aurora מנוהל
                </Link>
                <Link
                  to="/he/devsecops-daily"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  מנוי DevOps לפי דרישה
                </Link>
                <Link
                  to="/he/managed-cyber-defence"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsManagedOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  הגנת סייבר מנוהלת 24/7
                </Link>
              </div>
            )}
          </div>
          <div className="he-mobile-nav-group">
            <button
              type="button"
              className="he-mobile-nav-group-trigger"
              onClick={() => setIsHostingOpen((prev) => !prev)}
              aria-expanded={isHostingOpen}
            >
              <span>אחסון וענן</span>
              <i className={`las ${isHostingOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
            </button>
            {isHostingOpen && (
              <div className="he-mobile-nav-sublinks">
                <a
                  href="/he#hosting-cloud"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  כל האחסון והענן
                </a>
                <Link
                  to="/he/shared-hosting"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  אחסון אתרים
                </Link>
                <Link
                  to="/he/compute"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  שרתי ענן VPS
                </Link>
                <Link
                  to="/he/wordpress-hosting"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  אחסון וורדפרס
                </Link>
                <Link
                  to="/he/woocommerce"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  אחסון WooCommerce
                </Link>
                <Link
                  to="/he/nextjs-hosting"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  אחסון Next.js
                </Link>
                <Link
                  to="/marketplace"
                  state={{ language: 'he' }}
                  className="he-mobile-nav-sublink he-mobile-nav-sublink-subtle"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  מוצרי ענן מנוהלים
                </Link>
                <a
                  href="https://my.epicfinal.com/cart.php?a=add&domain=register&language=hebrew"
                  className="he-mobile-nav-sublink"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  רישום דומיין
                </a>
                <Link
                  to="/he/wordpress"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsHostingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  וורדפרס בניהול מלא
                </Link>
              </div>
            )}
          </div>
          <div className="he-mobile-nav-group">
            <button
              type="button"
              className="he-mobile-nav-group-trigger"
              onClick={() => setIsSmallBusinessOpen((prev) => !prev)}
              aria-expanded={isSmallBusinessOpen}
            >
              <span>{'\u05e2\u05e1\u05e7\u05d9\u05dd \u05e7\u05d8\u05e0\u05d9\u05dd'}</span>
              <i className={`las ${isSmallBusinessOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
            </button>
            {isSmallBusinessOpen && (
              <div className="he-mobile-nav-sublinks">
                <div className="he-small-business-entry he-small-business-entry--mobile">
                  <a
                    href="https://promo.eu.epicfinal-cloud.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="he-small-business-entry-title"
                    onClick={() => setIsMobileNavOpen(false)}
                  >
                    בניית אתרים לעסקים
                  </a>
                  <span className="he-small-business-entry-subtitle">אתרים מקצועיים, חנויות, אחסון ותחזוקה</span>
                </div>
                <div className="he-small-business-entry he-small-business-entry--mobile">
                  <a
                    href="https://growth.epicfinal.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="he-small-business-entry-title"
                    onClick={() => setIsMobileNavOpen(false)}
                  >
                    מערכות שיווק ומכירות
                  </a>
                  <span className="he-small-business-entry-subtitle">לידים, CRM, אוטומציות, דאטה ו־AI</span>
                </div>
                <div className="he-small-business-entry he-small-business-entry--mobile">
                  <Link
                    to="/he/tech-growth"
                    className="he-small-business-entry-title"
                    onClick={() => setIsMobileNavOpen(false)}
                  >
                    ליווי טכנולוגי לעסקים
                  </Link>
                  <span className="he-small-business-entry-subtitle">ייעוץ, מערכות ניהול, אוטומציה ודאטה</span>
                </div>
              </div>
            )}
          </div>
          <div className="he-mobile-nav-group">
            <button
              type="button"
              className="he-mobile-nav-group-trigger"
              onClick={() => setIsLegalOpen((prev) => !prev)}
              aria-expanded={isLegalOpen}
            >
              <span>תנאים ופרטיות</span>
              <i className={`las ${isLegalOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
            </button>
            {isLegalOpen && (
              <div className="he-mobile-nav-sublinks">
                <Link
                  to="/terms_conditions#hebrew-section"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsLegalOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  תנאי שימוש
                </Link>
                <Link
                  to="/privacy_policy#hebrew-version"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsLegalOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  מדיניות הפרטיות
                </Link>
              </div>
            )}
          </div>
          <div className="he-mobile-nav-group">
            <button
              type="button"
              className="he-mobile-nav-group-trigger"
              onClick={() => setIsPricingOpen((prev) => !prev)}
              aria-expanded={isPricingOpen}
            >
              <span>מחירים</span>
              <i className={`las ${isPricingOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
            </button>
            {isPricingOpen && (
              <div className="he-mobile-nav-sublinks">
                <Link
                  to="/pricing-he"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsPricingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  מנוי DevSecOps ONE
                </Link>
                <Link
                  to="/he/pricing-calculator"
                  className="he-mobile-nav-sublink"
                  onClick={() => {
                    setIsPricingOpen(false);
                    setIsMobileNavOpen(false);
                  }}
                >
                  מחשבון עלות
                </Link>
              </div>
            )}
          </div>
          {navItems.map((item) => (
            item.to.includes('#') ? (
              <a
                key={item.to}
                href={item.to}
                className="he-mobile-nav-link"
                onClick={() => setIsMobileNavOpen(false)}
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                className="he-mobile-nav-link"
                onClick={() => setIsMobileNavOpen(false)}
              >
                {item.label}
              </Link>
            )
          ))}
        </div>
      </div>
    </>
  );
};

// Hide Headers Button (shown when headers are visible on Hebrew pages)
const HideHeadersButton = ({ onHideHeaders }) => {
  return (
    <button
      onClick={onHideHeaders}
      style={{
        position: 'fixed',
        top: '10px',
        right: '20px',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: 'white',
        padding: '8px 16px',
        borderRadius: '20px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
        transition: 'all 0.3s ease',
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(239, 68, 68, 0.4)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)';
      }}
    >
      <i className="las la-times" style={{ fontSize: '16px' }}></i>
      <span>הסתר תפריט</span>
    </button>
  );
};

function App() {

  const location = useLocation();

  const [isAuthenticated, setIsAuthenticated] = useState(true); // for /verify.

  // Hebrew pages header visibility state
  const [showHeadersOnHebrew, setShowHeadersOnHebrew] = useState(false);

  // Mobile info dropdown state
  const [showMobileInfo, setShowMobileInfo] = useState(false);

  // Check if current page is a Hebrew page
  const isHebrewPage = location.pathname === '/he' ||
    location.pathname === '/pricing-he' ||
    location.pathname === '/he/pricing-calculator' ||
    location.pathname.startsWith('/he/');

  // Reset header visibility when navigating away from Hebrew pages
  useEffect(() => {
    if (!isHebrewPage) {
      setShowHeadersOnHebrew(false);
    }
  }, [location.pathname, isHebrewPage]);

  const getUrl = (pathname) => {
    let pathArray = pathname.split('/');
    return `/${pathArray[1]}` === '/coming_soon'
      ? true
      : `/${pathArray[1]}` === '/maintenance'
        ? true
        : `/${pathArray[1]}` === '/error_404'
          ? true
          : `/${pathArray[1]}` === '*'
            ? true
            : false;
  };

  const setHeader = (pathname) => {
    let pathArray = pathname.split('/');
    return `/${pathArray[1]}` === '/index4' ? true : false;
  }

  const setFooter = (pathname) => {
    let pathArray = pathname.split('/');
    return `/${pathArray[1]}` === '/index10' ? false : true;
  };
  const scrollbarStyle = `
  ::-webkit-scrollbar {
    display: none;
  }`;

  useEffect(() => {
    return installThirdPartyFocusScrollGuard();
  }, []);

  useEffect(() => {
    const handlePopstate = () => {
      window.location.reload(); // Refresh the page on popstate event (back button).
    };

    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
      return;
    }

    const targetId = location.hash.slice(1);
    const scrollToHash = () => {
      const target = document.getElementById(targetId);
      if (target) {
        const offsetMap = {
          solutions: 9,
          'hosting-cloud': 32,
          'managed-services': -8,
          'about-us': 32,
        };
        let offset = offsetMap[targetId] ?? 0;
        if (targetId === 'solutions' && window.innerWidth <= 768) {
          offset += 5;
        }
        const top = target.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    const timeoutId = window.setTimeout(scrollToHash, 80);
    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.hash]);

  // Google Ads GTAG Page View Tracking
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'AW-11461100984', {
        'page_path': location.pathname,
      });
    }
  }, [location.pathname]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* Hide NotificationBanner on Hebrew pages when headers are hidden */}
      {(!isHebrewPage || showHeadersOnHebrew) && <NotificationBanner />}
      <GlobalDeploy />

      {getUrl(location.pathname) ?
        <Routes>
          <Route path="/coming_soon" element={<ComingSoon />} />
          <Route path="/error_404" element={<Error404 />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="*" element={<Outlet />}>
            {/* Render the Error404 component without Header and Footer */}
            <Route index element={<Error404WithoutHeaderFooter />} />
          </Route>
        </Routes> :

        <div className={`page-wrapper ${isHebrewPage && !showHeadersOnHebrew ? 'hebrew-no-header' : ''}`}>
          {/* Hebrew pages: show toggle button when headers are hidden */}
          {isHebrewPage && !showHeadersOnHebrew && (
            <>
              <HebrewHeaderToggle />
              {/* Show StickyButtons separately when headers are hidden on Hebrew pages */}
              <StickyButtons forceHidden={true} />
            </>
          )}

          {/* Hebrew pages: show hide button when headers are visible */}
          {isHebrewPage && showHeadersOnHebrew && (
            <HideHeadersButton onHideHeaders={() => setShowHeadersOnHebrew(false)} />
          )}

          {/* Show headers: always on non-Hebrew pages, or when toggled on Hebrew pages */}
          {(!isHebrewPage || showHeadersOnHebrew) && (
            <div className="combined-headers-mobile">
              {setHeader(location.pathname) ? <Header2 /> : <Header1 />}

              {/* Mobile Info Section - Between header and TopCategoriesBar */}
              <div className="header1-mobile-info-section">
                <div className="container">
                  <button
                    className="header1-mobile-info-button"
                    onClick={() => setShowMobileInfo(!showMobileInfo)}
                  >
                    <div className="header1-info-icon-wrapper">
                      <i className="las la-info-circle"></i>
                    </div>
                    <span className="header1-info-text">Company Information</span>
                  </button>

                  <div className={`header1-company-info-dropdown ${showMobileInfo ? 'active' : ''}`}>
                    <div className="header1-company-info-content">
                      {/* Contact Info */}
                      <div className="header1-info-item">
                        <i className="las la-phone"></i>
                        <div>
                          <strong>Contact</strong>
                          <p>(+972) 515-564-767</p>
                        </div>
                      </div>
                      <div className="header1-info-item">
                        <i className="las la-clock"></i>
                        <div>
                          <strong>Hours</strong>
                          <p>8:30am - 5pm (GMT+2)</p>
                        </div>
                      </div>

                      {/* Company */}
                      <div className="header1-info-section-title">Company</div>
                      <Link to="/about-us" className="header1-info-link" onClick={() => setShowMobileInfo(false)}>
                        <i className="las la-building"></i>
                        About EpicFinal
                      </Link>
                      <Link to="/career" className="header1-info-link" onClick={() => setShowMobileInfo(false)}>
                        <i className="las la-briefcase"></i>
                        Career
                      </Link>

                      {/* Solutions */}
                      <div className="header1-info-section-title header1-info-section-title--solutions">
                        {isHebrewPage ? 'פתרונות טכנולוגיים' : 'Solutions'}
                      </div>

                      {isHebrewPage ? (
                        <>
                          <Link to="/he/genai" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}>GenAI - סביבת בינה מלאכותית לפיתוח אפליקציות</Link>
                          <Link to="/he/development" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-code"></i>פיתוח תוכנה</Link>
                          <Link to="/he/operations" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-cogs"></i>תשתיות ופעולות IT</Link>
                          <Link to="/he/security" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-shield-alt"></i>אבטחת מידע</Link>
                          <Link to="/he/consulting" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-comments"></i>ייעוץ וליווי טכנולוגי</Link>
                          <Link to="/he/academy" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-graduation-cap"></i>אקדמיה והכשרות</Link>
                          <Link to="/he/disaster_recovery" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-life-ring"></i>התאוששות קריסה (DR)</Link>
                          <Link to="/he/managed_service" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-server"></i>ניהול שרתים (Managed)</Link>
                          <Link to="/he/noc" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-network-wired"></i>מרכז בקרה ורשת (NOC)</Link>
                          <Link to="/he/private_cloud" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-cloud"></i>פתרונות ענן פרטי</Link>
                          <Link to="/he/dataops" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-database"></i>תשתיות DataOps</Link>
                        </>
                      ) : (
                        <>
                          <Link to="/Development" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-code"></i>PrimeCode</Link>
                          <Link to="/Operations" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-cogs"></i>IT Operations Excellence</Link>
                          <Link to="/Security" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-shield-alt"></i>OpsSecurity</Link>
                          <Link to="/Consulting" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-comments"></i>Consulting</Link>
                          <Link to="/Academy" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-graduation-cap"></i>Learn Academy</Link>
                          <Link to="/Disaster_Recovery" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-life-ring"></i>Disaster Recovery</Link>
                          <Link to="/Managed_Service" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-server"></i>ServerCare Plus</Link>
                          <Link to="/NOC" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-network-wired"></i>Network Operation Center</Link>
                          <Link to="/Private_Cloud" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-cloud"></i>Private Cloud</Link>
                          <Link to="/dataops" className="header1-info-link header1-info-link--solutions" onClick={() => setShowMobileInfo(false)}><i className="las la-database"></i>DataOps</Link>
                        </>
                      )}

                      {/* FAQs & Legal */}
                      <div className="header1-info-section-title">FAQs & Legal</div>
                      <Link to="/faq" className="header1-info-link" onClick={() => setShowMobileInfo(false)}>
                        <i className="las la-question-circle"></i>
                        FAQ
                      </Link>
                      <Link to="/privacy_policy" className="header1-info-link" onClick={() => setShowMobileInfo(false)}>
                        <i className="las la-file-contract"></i>
                        Privacy & Policy
                      </Link>
                      <Link to="/terms_conditions" className="header1-info-link" onClick={() => setShowMobileInfo(false)}>
                        <i className="las la-file-alt"></i>
                        Terms & Conditions
                      </Link>

                      {/* Other Links */}
                      <div className="header1-info-section-title">Quick Links</div>
                      <Link to="/pricing" className="header1-info-link" onClick={() => setShowMobileInfo(false)}>
                        <i className="las la-tag"></i>
                        DevSecOps Subscription
                      </Link>
                      <Link to="/Calculator" className="header1-info-link" onClick={() => setShowMobileInfo(false)}>
                        <i className="las la-calculator"></i>
                        Pricing Calculator
                      </Link>
                      <a
                        href="https://boarding.eu.epicfinal-cloud.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="header1-info-link"
                      >
                        <i className="las la-sign-in-alt"></i>
                        Platform Login
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <TopCategoriesBar />
            </div>
          )}
          <Routes>
            {/* difaultHompage */}
            <Route path='/' element={<HomePage />} />
            {/* <Route path='/Login' element={<Login />} /> */}
            {/* <Route path='/Signup' element={<Signup />} /> */}
            {/* difaultHompage */}

            {/* Verify                                           NOT WORKING*/}
            <Route
              path="/"
              element={<Signupcomponent setIsAuthenticated={setIsAuthenticated} />}
            />
            <Route
              path="/verify"
              element={
                isAuthenticated ? (
                  <Verification />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />


            {/* NavbarHome */}

            <Route path='/' element={<Landing1 />} />
            {/* <Route path='/index2' element={<Landing2 />} />
            <Route path='/index3' element={<Landing3 />} />
            <Route path='/index4' element={<Landing4 />} /> */}


            <Route path='/blog_card' element={<BlogStyle />} />
            <Route path='/he/blog_card' element={<BlogStyle />} />
            <Route path='/blog_listing_1' element={<BlogListing1 />} />
            <Route path='/blog_listing_2' element={<BlogListing2 />} />
            <Route path='/blog/:slug' element={<BlogSingle />} />
            <Route path='/he/blog/:slug' element={<BlogSingle />} />
            <Route path='/blog-single' element={<Navigate to="/blog_card" replace />} />

            {/* NavbarHome */}
            <Route path='/about-us' element={<AboutUs />} />
            <Route path='/about-us2' element={<AboutUs2 />} />
            <Route path='/career' element={<Career />} />
            <Route path='/career-single' element={<CareerSingle />} />
            <Route path='/contact1' element={<Contact1 />} />
            <Route path='/contact2' element={<Contact2 />} />
            <Route path='/sign_in' element={<Login />} />
            <Route path='/sign_up' element={<Signup />} />
            <Route path='/sign_in_2' element={<Signin2 />} />
            <Route path='/forgot_password' element={<Forgotpassword />} />

            <Route path='/faq' element={<FAQ />} />
            <Route path='/pricing' element={<Pricing />} />
            <Route path='/privacy_policy' element={<PrivacyPolicy />} />
            <Route path='/terms_conditions' element={<TermsConditions />} />

            <Route path='/product-grid' element={<ProductGrid />} />
            <Route path='/product-list' element={<ProductList />} />
            <Route path='/product-single' element={<ProductSingle />} />
            <Route path='/cart' element={<ProductCart />} />
            <Route path='/checkout' element={<CheckOut />} />
            <Route path='/order-complete' element={<OrderComplete />} />

            <Route path='/Accordion' element={<AccordionPage />} />
            <Route path='/Counter' element={<CounterPage />} />
            <Route path='/feature_box' element={<FeatureIconPage />} />
            <Route path='/Price_table' element={<FeaturePricePage />} />
            <Route path='/team' element={<FeatureTeamPage />} />
            <Route path='/testimonial' element={<FeatureTestimonialPage />} />
            <Route path='/development' element={<Dev />} />
            <Route path='/Operations' element={<Ops />} />
            <Route path='/Security' element={<Sec />} />
            <Route path='/Consulting' element={<Consulting />} />
            <Route path='/Academy' element={<Aca />} />
            <Route path='/he' element={<HE />} />
            <Route path='/pricing-he' element={<PricingHe />} />
            <Route path='/Disaster_Recovery' element={<Disaster />} />
            <Route path='/Managed_Service' element={<ServerCare />} />
            <Route path='/NOC' element={<NOC />} />
            <Route path='/Private_Cloud' element={<PrivateCloud />} />
            <Route path='/Calculator' element={<Calculator />} />
            <Route path='/Pricing-Calculator' element={<PricingCalculator />} />
            <Route path='/he/pricing-calculator' element={<PricingCalculator />} />
            <Route path='/marketplace' element={<Marketplace />} />


            <Route path='/blog' element={<FeatureBlogPage />} />
            <Route path='/wordpress' element={<Navigate to="/he/wordpress" replace />} />
            <Route path='/he/wordpress' element={<WordPress />} />
            <Route path='/wordpress-en' element={<WordPressEn />} />
            <Route path='/woocommerce' element={<Navigate to="/he/woocommerce" replace />} />
            <Route path='/he/woocommerce' element={<WooCommerce />} />
            <Route path='/woocommerce-en' element={<WooCommerceEn />} />
            <Route path='/cloud' element={<Cloud />} />
            <Route path='/cloud-en' element={<CloudEn />} />
            <Route path='/web-hosting' element={<WebHosting />} />
            <Route path='/compute' element={<Compute />} />
            <Route path='/managed-services' element={<ManagedServices />} />
            <Route path='/managed-cdn' element={<ManagedCDN />} />
            <Route path='/server-management' element={<ServerManagement />} />
            <Route path='/aws-management' element={<AWSManagement />} />
            <Route path='/aurora-database' element={<AuroraDB />} />
            <Route path='/centralized-monitoring' element={<CentralizedMonitoring />} />
            <Route path='/devsecops-daily' element={<DevSecOpsDaily />} />
            <Route path='/devsecops-weekly' element={<DevSecOpsWeekly />} />
            <Route path='/managed-cyber-defence' element={<ManagedCyberDefence />} />
            <Route path='/shared-hosting' element={<SharedHosting />} />
            <Route path='/wordpress-hosting' element={<WordPressHosting />} />
            <Route path='/nextjs-hosting' element={<NextJsHosting />} />
            <Route path='/unmanaged-wordpress' element={<UnmanagedWordPress />} />
            <Route path='/dataops' element={<DataOps />} />

            {/* Hebrew Solutions Routes */}
            <Route path='/he/development' element={<DevHe />} />
            <Route path='/he/operations' element={<OpsHe />} />
            <Route path='/he/security' element={<SecHe />} />
            <Route path='/he/consulting' element={<ConsHe />} />
            <Route path='/he/academy' element={<AcaHe />} />
            <Route path='/he/disaster_recovery' element={<DisasterHe />} />
            <Route path='/he/managed_service' element={<ServerCareHe />} />
            <Route path='/he/noc' element={<NOCHe />} />
            <Route path='/he/private_cloud' element={<PrivateCloudHe />} />
            <Route path='/he/dataops' element={<DataOpsHe />} />
            <Route path='/he/tech-growth' element={<TechGrowthHe />} />
            <Route path='/he/platform' element={<ProjectsPlatformHe />} />
            <Route path='/he/genai' element={<GenAIHe />} />
            <Route path='/genai' element={<GenAI />} />

            {/* Hebrew Managed Services Routes */}
            <Route path='/he/managed-cdn' element={<ManagedCDNHe />} />
            <Route path='/he/server-management' element={<ServerManagementHe />} />
            <Route path='/he/aws-management' element={<AWSManagementHe />} />
            <Route path='/he/aurora-database' element={<AuroraDBHe />} />
            <Route path='/he/centralized-monitoring' element={<CentralizedMonitoringHe />} />
            <Route path='/he/devsecops-daily' element={<DevSecOpsDailyHe />} />
            <Route path='/he/managed-cyber-defence' element={<ManagedCyberDefenceHe />} />
            <Route path='/he/shared-hosting' element={<SharedHostingHe />} />
            <Route path='/he/compute' element={<ComputeHe />} />
            <Route path='/he/wordpress-hosting' element={<WordPressHostingHe />} />
            <Route path='/he/nextjs-hosting' element={<NextJsHostingHe />} />

            <Route path="*" element={<Error404 />} />

            {/* Company */}
          </Routes>
          {setFooter(location.pathname) && <Footer1 />}
        </div>
      }
    </>

  )

}


export default App


